import { CreateIconArguments } from '##/icons/Icon/helpers';

import IconCommentDeleteFilledSizeL from './IconCommentDeleteFilled_size_l';
import IconCommentDeleteFilledSizeM from './IconCommentDeleteFilled_size_m';
import IconCommentDeleteFilledSizeS from './IconCommentDeleteFilled_size_s';
import IconCommentDeleteFilledSizeXs from './IconCommentDeleteFilled_size_xs';

const props: CreateIconArguments = {
  l: IconCommentDeleteFilledSizeL,
  m: IconCommentDeleteFilledSizeM,
  s: IconCommentDeleteFilledSizeS,
  xs: IconCommentDeleteFilledSizeXs,
  name: 'IconCommentDeleteFilled',
  renderType: { l: 'use', m: 'use', s: 'use', xs: 'use' },
  color: 'mono',
};

export default props;
